// extracted by mini-css-extract-plugin
export default {"white_label_item":"WhiteLabel_white_label_item__1Q3pG","acc_edit__wrapper":"WhiteLabel_acc_edit__wrapper__3FBNK","container":"WhiteLabel_container__KI6ZX"};